(() => {
  if (window.saCartDrawer) return;

  const pending = new Map();

  const open = (cartUrl) => {
    try {
      if (typeof window.essentialCartApi?.openCart === 'function') {
        Promise.resolve(window.essentialCartApi.openCart()).catch(() => window.location.assign(cartUrl));
        return;
      }
    } catch {}
    window.location.assign(cartUrl);
  };

  const restore = (form) => {
    const state = pending.get(form);
    if (!state) return;
    state.controls.forEach(({control, disabled}) => { control.disabled = disabled; });
    state.labels.forEach(({label, text}) => { label.textContent = text; });
    form.removeAttribute('aria-busy');
    pending.delete(form);
  };

  window.saCartDrawer = {open};

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches?.('form[data-sa-ajax-cart]')) return;
    if (form.querySelector('sa-axis-bundle-offer')?.initialized) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending.has(form)) return;

    const payload = new FormData(form);
    const errorNode = form.querySelector('[data-sa-cart-error]');
    const state = {
      controls: Array.from(form.elements).filter(control => 'disabled' in control).map(control => ({control, disabled: control.disabled})),
      labels: Array.from(form.querySelectorAll('[data-submit-label]')).map(label => ({label, text: label.textContent}))
    };
    pending.set(form, state);
    state.controls.forEach(({control}) => { control.disabled = true; });
    state.labels.forEach(({label}) => { label.textContent = form.dataset.addingLabel; });
    form.setAttribute('aria-busy', 'true');
    if (errorNode) errorNode.hidden = true;

    try {
      const url = new URL(form.action, window.location.href);
      if (!url.pathname.endsWith('.js')) url.pathname += '.js';
      const response = await fetch(url.toString(), {
        method: 'POST',
        headers: {'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
        body: payload
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : form.dataset.errorMessage);
    } catch (error) {
      restore(form);
      if (errorNode) {
        errorNode.textContent = error.message || form.dataset.errorMessage;
        errorNode.hidden = false;
        errorNode.focus({preventScroll: true});
      }
      return;
    }

    restore(form);
    open(form.dataset.cartUrl);
  }, true);

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) Array.from(pending.keys()).forEach(restore);
  });
})();
